interface PrimaryColorButtonProps {
  text: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  icon?: React.ReactNode;
  isLoading?: boolean;
  disabled?: boolean;
  className?: string;
  type?: "button" | "submit" | "reset";
}

const PrimaryColorButton: React.FC<PrimaryColorButtonProps> = ({
  text,
  onClick,
  icon,
  isLoading = false,
  disabled = false,
  className = "",
  type,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`btn ${disabled ? "btn-disabled" : ""} ${
        isLoading ? "loading" : ""
      } w-full md:w-auto rounded-full flex items-center justify-center font-bold px-4 py-2 min-w-[130px] md:max-w-[230px] lg:max-w-[230px] ${className}`}
      disabled={disabled || isLoading}
    >
      {icon && <span className="flex-shrink-0 mr-2">{icon}</span>}
      <span className="text-center text-sm md:text-base">{text}</span>
    </button>
  );
};

export default PrimaryColorButton;
